import { MessagingAvailabilityReason } from './types';

export const isValidMessagingAvailabilityReason = (value: unknown): value is MessagingAvailabilityReason => {
  return Object.values(MessagingAvailabilityReason).some(reason => reason === value);
};
